var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandleStick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Candlesticks_Up_Line",
    "data-name": "icons/Candlesticks Up/Line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.333,
    height: 20,
    viewBox: "0 0 13.333 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M.833,20A.834.834,0,0,1,0,19.167V15.833a.833.833,0,1,1,1.666,0v3.334A.834.834,0,0,1,.833,20Zm8.333-3.334a.834.834,0,0,1-.833-.833v-5a.833.833,0,1,1,1.667,0v5A.834.834,0,0,1,9.167,16.667Zm-8.333-5A.835.835,0,0,1,0,10.833V4.167a.833.833,0,1,1,1.666,0v6.666A.835.835,0,0,1,.833,11.667ZM9.167,3.333A.834.834,0,0,1,8.333,2.5V.833A.833.833,0,0,1,10,.833V2.5A.834.834,0,0,1,9.167,3.333Z",
    transform: "translate(1.667)",
    fill: "#777e90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M2.5,15A2.5,2.5,0,0,1,0,12.5V10.833a2.5,2.5,0,0,1,5,0V12.5A2.5,2.5,0,0,1,2.5,15Zm0-5a.834.834,0,0,0-.833.833V12.5a.833.833,0,0,0,1.667,0V10.833A.834.834,0,0,0,2.5,10Zm8.333,0a2.5,2.5,0,0,1-2.5-2.5v-5a2.5,2.5,0,0,1,5,0v5A2.5,2.5,0,0,1,10.833,10Zm0-8.333A.834.834,0,0,0,10,2.5v5a.834.834,0,0,0,1.667,0v-5A.835.835,0,0,0,10.833,1.666Z",
    transform: "translate(0 1.667)",
    fill: "#777e90"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandleStick);
export default __webpack_public_path__ + "static/media/candleStick.b299a28cb0f9b74b5694c592363decac.svg";
export { ForwardRef as ReactComponent };